//
//
//
//
//
//
//

import {getContentByCode} from "@/utils/utils";

export default {
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    },
    showMobText: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    getContent(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    }
  },
  chimera: {
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'qr',
        auto: true,
        params: {
          code: ['qr'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    }
  }
}
